// CTACierre.jsx — bloque de llamado a la acción de cierre, antes del footer.

import React from 'react'
import { trackCta } from '../../lib/analytics.js'

function CTACierre({ onScrollTo }) {
  return (
    <section style={{ paddingTop: 40, paddingBottom: 40, borderTop: "1px solid var(--line)" }}>
      <div className="wrap">
        <div
          style={{
            position: "relative",
            padding: "72px 48px",
            borderRadius: 24,
            background: "linear-gradient(135deg, rgba(232,169,59,0.10), rgba(230,57,70,0.06))",
            border: "1px solid var(--line-2)",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          <div className="eyebrow" style={{ justifyContent: "center", marginBottom: 18 }}>
            ¡Súmate a la campaña!
          </div>
          <h2 className="pullquote" style={{ maxWidth: 18 + "ch", margin: "0 auto", marginBottom: 28 }}>
            Con tu aporte <em>llegaremos</em> más alto
          </h2>
          <button
            className="btn btn-primary btn-lg"
            onClick={() => {
              trackCta("cta_cierre")
              onScrollTo("como")
            }}
          >
            Quiero ser parte de la escala
          </button>
          <div className="kicker" style={{ marginTop: 16 }}>#MecanicaParaQuilpue</div>
        </div>
      </div>
    </section>
  );
}

export { CTACierre };
